





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Tooltip extends Vue {
	@Prop({ default: false })
	darkMode!: boolean;

	@Prop({ default: 'above' })
	position!: 'above' | 'below';

	@Prop({ default: 'click' })
	trigger!: 'click' | 'hover';

	$refs!: {
		arrow: HTMLElement;
		tooltip: HTMLElement;
		trigger: HTMLElement;
	};

	visible = false;

	get triggers(): object {
		if (this.trigger === 'hover') {
			return { mouseenter: this.showTooltip, mouseleave: this.hideTooltip };
		} else {
			return { click: this.toggleTooltip };
		}
	}

	get visibilityStyle(): object {
		const styles: Record<string, string | number> = { visibility: 'visible', opacity: 1 };
		if (this.trigger === 'hover') {
			styles['user-select'] = 'none';
		}
		return this.visible ? styles : {};
	}

	@Watch('visible')
	onVisibilityChange(visibility: boolean): void {
		if (this.trigger === 'click') {
			if (visibility) {
				document.addEventListener('click', this.clickOutsideHandler);
			} else {
				document.removeEventListener('click', this.clickOutsideHandler);
			}
		}
	}

	mounted(): void {
		const below = this.position === 'below';

		const position = this.$refs.trigger.getBoundingClientRect();
		const arrowWidth = 7;
		const defaultMargin = 144;
		const rightPosition = window.innerWidth - position.left;
		const leftPosition = position.left;

		if (leftPosition < defaultMargin) {
			const offset = defaultMargin - leftPosition;
			this.$refs.tooltip.style.marginLeft = `${-defaultMargin + offset}px`;
			this.$refs.arrow.style.marginLeft = `${-offset - arrowWidth}px`;
		}

		if (rightPosition < defaultMargin) {
			const offset = defaultMargin - rightPosition + 10;
			this.$refs.tooltip.style.marginLeft = '0px';
			this.$refs.tooltip.style.left = 'auto';
			this.$refs.tooltip.style.right = '50.5%';
			this.$refs.tooltip.style.marginRight = `${-defaultMargin + offset}px`;
			this.$refs.arrow.style.marginLeft = '0px';
			this.$refs.arrow.style.marginRight = `${-offset - arrowWidth}px`;
			this.$refs.arrow.style.left = 'auto';
			this.$refs.arrow.style.right = '50.5%';
		}

		if (below) {
			this.$refs.tooltip.style.bottom = 'auto';
			this.$refs.tooltip.style.top = '125%';
			this.$refs.arrow.style.top = 'auto';
			this.$refs.arrow.style.bottom = '100%';
			this.$refs.arrow.style.borderColor = 'transparent transparent #ffffff transparent';
		}
	}

	toggleTooltip(event?: PointerEvent): void {
		event?.stopPropagation();

		if (this.$root.$refs.tooltip && (this.$root.$refs.tooltip as Vue).$el !== this.$el) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$root.$refs.tooltip as any).hideTooltip();
		}

		this.visible = !this.visible;

		if (this.visible) {
			this.$root.$refs.tooltip = this;
		}
	}

	showTooltip(event?: MouseEvent): void {
		event?.stopPropagation();
		
		this.visible = true;
		this.$root.$refs.tooltip = this;
	}

	beforeDestroy(): void {
		document.removeEventListener('click', this.clickOutsideHandler);
	}

	clickOutsideHandler(event: MouseEvent): void {
		if (!this.$el.contains(event.target as Node)) {
			this.hideTooltip();
		}
	}

	hideTooltip(event?: MouseEvent): void {
		event?.stopPropagation();
		
		this.visible = false;
	}
}
